// extracted by mini-css-extract-plugin
export default {"page":"PaymentStatusPage_page__GdoGJ","container":"PaymentStatusPage_container__oA3H-"};